import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=abcf5e6a&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abcf5e6a')) {
      api.createRecord('abcf5e6a', component.options)
    } else {
      api.reload('abcf5e6a', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=abcf5e6a&", function () {
      api.rerender('abcf5e6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2D7JXo05vHXns/JS/stardisplay.vue"
export default component.exports